import { ICON_TYPE_TO_TEXT_MAPPER } from '@/shared/consts';
import type { EMainPageAdvantageIcons } from '@/shared/types/mainPage';

import styles from './IconSelectLabel.module.scss';

interface IProp {
  iconType: EMainPageAdvantageIcons;
  textClassName?: string;
}

export const IconSelectLabel = ({ iconType, textClassName }: IProp) => (
  <div className={styles.wrapper}>
    <img
      className={styles.icon}
      src={`/images/mainPageAdvantageIcons/${iconType}.svg`}
      width={28}
      height={28}
      alt="Один из возможных логотипов преимущества школы"
    />
    <p className={textClassName}>{ICON_TYPE_TO_TEXT_MAPPER[iconType]}</p>
  </div>
);
